import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Box, Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import ROUTES from '../../../config/routes';

import PH1 from './affisch_1_a3_home_printer.png';
import PH2 from './affisch_2_a3_home_printer.png';
import PH3 from './affisch_3_a3_home_printer.png';
import PH2_ARA from './affisch_2_a2_ara_home_printer.png';
import PH3_ARA from './affisch_3_a2_ara_home_printer.png';

import P1 from './affisch_1_a3-2.png';
import P2 from './affisch_2_a3-2.png';
import P3 from './affisch_3_a3-2.png';
import P2_ARA from './affisch_2_a2_ara.png';
import P3_ARA from './affisch_3_a2_ara.png';

import PH4 from './Thumb_affisch_modersmalsdagen.png';
import PH5 from './Thumb_vimpel.png';
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tile: {
    maxWidth: '235px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  typeHeading: {
    marginTop: theme.spacing(7),
  },
  h3: {
    marginTop: theme.spacing(5),
    fontSize: '1.45rem',
  },
  h4: {
    marginTop: theme.spacing(4),
    fontSize: '1.3rem',
  },
}));

const Posters = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Fragment>
      <Typography gutterBottom={true} variant="h2" component="h2">
        Affischer
      </Typography>
      <Box pb={5}>
        Klicka på bilderna för att ladda ner affischer på svenska och arabiska.
        Affischerna finns i en version som är anpassad för att kunna skrivas ut
        på vanlig skrivare och en version anpassad för att skickas till
        tryckeri.
      </Box>

      <Typography
        className={classes.h3}
        gutterBottom={true}
        variant="h3"
        component="h3"
      >
        Internationella modersmålsdagen 2023
      </Typography>
      <Box pb={5}>
        Använd gärna materialet för att uppmärksamma internationella
        modersmålsdagen den 21 februari. Affischen finns i formaten A2 och A3.
        Vimplarna skrivs ut på dubbelsidiga A4-ark, klipps ut och klistras eller
        tejpas upp på ett snöre.
      </Box>
      <Box
        justifyContent="center"
        alignItems="center"
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        mb={9}
      >
        <Grid container spacing={3} space={3} className={classes.root}>
          <Grid item xs={12} md={6}>
            <Typography
              gutterBottom={true}
              variant="h4"
              component="h4"
              className={classes.h4}
            >
              Affisch A2
            </Typography>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch_Mitt-sprak-Mitt-bibliotek_A2.pdf`}
              download
              target="_blank"
              title="Ladda ned affisch för vanlig skrivare, A2"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_modersmalsdagen',
                  defaultMessage: 'Bild på poster',
                })}
                src={PH4}
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              gutterBottom={true}
              variant="h4"
              component="h4"
              className={classes.h4}
            >
              Affisch A3
            </Typography>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch_Mitt-sprak-Mitt-bibliotek_A3.pdf`}
              download
              target="_blank"
              title="Ladda ned affisch för vanlig skrivare, A3"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_modersmalsdagen',
                  defaultMessage: 'Bild på poster',
                })}
                src={PH4}
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              gutterBottom={true}
              variant="h4"
              component="h4"
              className={classes.h4}
            >
              Vimplar
            </Typography>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Vimpel_Mitt-sprak.pdf`}
              download
              target="_blank"
              title="Ladda ned vimplar för utskrift i vanlig skrivare"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.flags_modersmalsdagen',
                  defaultMessage: 'Bild på poster',
                })}
                src={PH5}
              />
            </Link>
          </Grid>
        </Grid>
      </Box>

      <Typography
        className={classes.h3}
        gutterBottom={true}
        variant="h3"
        component="h3"
        id="home_printer"
      >
        Affischer i A3 för vanlig skrivare
      </Typography>

      <Typography
        gutterBottom={true}
        variant="h4"
        component="h4"
        className={classes.h4}
      >
        Svenska
      </Typography>
      <Box
        justifyContent="center"
        alignItems="center"
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        mb={9}
      >
        <Grid container spacing={3} space={3} className={classes.root}>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 1 A3 vanlig skrivare.pdf`}
              download
              target="_blank"
              title="Ladda ned affisch för vanlig skrivare, version 1"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_sv.bedtime_story"',
                  defaultMessage: 'Bild på poster',
                })}
                src={PH1}
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 2 A3 vanlig skrivare.pdf`}
              download
              target="_blank"
              title="Ladda ned affisch för vanlig skrivare, version 2"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_sv.man_with_headphones_urban',
                  defaultMessage: 'Bild på poster',
                })}
                src={PH2}
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 3 A3 vanlig skrivare.pdf`}
              download
              target="_blank"
              title="Ladda ned affisch för vanlig skrivare, version 3"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_sv.grandpa_reading',
                  defaultMessage: 'Bild på poster',
                })}
                src={PH3}
              />
            </Link>
          </Grid>
        </Grid>
      </Box>

      <Typography
        gutterBottom={true}
        variant="h4"
        component="h4"
        className={classes.h4}
      >
        Arabiska
      </Typography>
      <Box
        justifyContent="center"
        alignItems="center"
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        mb={9}
      >
        <Grid container spacing={3} space={3} className={classes.root}>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 2 A2 vanlig skrivare ara.pdf`}
              download
              target="_blank"
              title="Ladda ned arabisk affisch för vanlig skrivare, version 2"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_ara.man_with_headphones_urban',
                  defaultMessage: 'Bild på poster',
                })}
                src={PH2_ARA}
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 3 A2 vanlig skrivare ara.pdf`}
              download
              target="_blank"
              title="Ladda ned arabisk affisch för vanlig skrivare, version 3"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_ara.grandpa_reading',
                  defaultMessage: 'Bild på poster',
                })}
                src={PH3_ARA}
              />
            </Link>
          </Grid>
        </Grid>
      </Box>

      <Box pb={5} pt={5} mb={9}>
        <Divider />
      </Box>

      <Typography
        className={classes.h3}
        gutterBottom={true}
        variant="h3"
        component="h3"
        id="printing"
      >
        Affischer i A3/A2 för tryckeri
      </Typography>

      <Typography
        gutterBottom={true}
        variant="h4"
        component="h4"
        className={classes.h4}
      >
        Svenska
      </Typography>
      <Box
        justifyContent="center"
        alignItems="center"
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        mb={9}
      >
        <Grid container spacing={3} space={3} className={classes.root}>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 1 A3-A2 obestruket papper.pdf`}
              download
              target="_blank"
              title="Ladda ned affisch för tryckeri, version 1"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_printing_sv.bedtime_story',
                  defaultMessage: 'Bild på poster',
                })}
                src={P1}
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 2 A3-A2 obestruket papper.pdf`}
              download
              target="_blank"
              title="Ladda ned affisch för tryckeri, version 2"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_printing_sv.man_with_headphones_urban',
                  defaultMessage: 'Bild på poster',
                })}
                src={P2}
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 3 A3-A2 obestruket papper.pdf`}
              download
              target="_blank"
              title="Ladda ned affisch för tryckeri, version 3"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_printing_sv.grandpa_reading',
                  defaultMessage: 'Bild på poster',
                })}
                src={P3}
              />
            </Link>
          </Grid>
        </Grid>
      </Box>

      <Typography
        gutterBottom={true}
        variant="h4"
        component="h4"
        className={classes.h4}
      >
        Arabiska
      </Typography>
      <Box
        justifyContent="center"
        alignItems="center"
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        mb={9}
      >
        <Grid container spacing={3} space={3} className={classes.root}>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 2 A2 tryckeri ara.pdf`}
              download
              target="_blank"
              title="Ladda ned arabisk affisch för tryckeri, version 2"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_printing_ara.man_with_headphones_urban',
                  defaultMessage: 'Bild på poster',
                })}
                src={P2_ARA}
              />
            </Link>
          </Grid>
          <Grid item xs={12} md={6}>
            <Link
              to={`/${ROUTES.DOWNLOADS}/${ROUTES.CI_POSTERS}/Affisch 3 A2 tryckeri ara.pdf`}
              download
              target="_blank"
              title="Ladda ned arabisk affisch för tryckeri, version 3"
            >
              <img
                alt={intl.formatMessage({
                  id: 'alt_text.download_preview.poster_printing_ara.grandpa_reading',
                  defaultMessage: 'Bild på poster',
                })}
                src={P3_ARA}
              />
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
};

export default Posters;
